<tr class="rt-new">
  <td></td>
  <td [attr.colspan]="sarakkeita() - 1">
    <div class="rt-new-box">
      <mat-icon class="rt-new-ikoni">add</mat-icon>
      <input #hakukentta [formField]="hakusana" [placeholder]="'lasku.kirjoita-rivi-tai-hae-tuote' | translate | async" [attr.aria-label]="'lasku.rivit.uusi-rivi' | translate | async" (focus)="avaaValikko()" (blur)="suljeValikkoViiveella()" (keydown)="kasitteleHaunNappain($event)" autocomplete="off" data-lpignore="true" />
      @if (valikkoOnAuki() && hakusanaOnAnnettu) {
        <div class="dropdown">
          @if (ehdotukset().length > 0) {
            <div class="dd-sec">
              <mat-icon>inventory_2</mat-icon>
              {{ 'lasku.tuoterekisterista' | translate | async }}
            </div>
          }
          @for (ehdotus of ehdotukset(); track ehdotus.avain; let k = $index) {
            <button type="button" [class.hi]="aktiivinenIndeksi() === k" (mousedown)="$event.preventDefault(); valitseRekisterituote(ehdotus)" (mouseenter)="aktiivinenIndeksi.set(k)">
              <span class="ehdotuksen-nimi">{{ ehdotus.nimi }}</span>
              @if (ehdotus.hinta !== undefined) {
                <span class="ehdotuksen-hinta">{{ ehdotus.hinta | lmoney: laskunValuutta() | async }}{{ ehdotus.yksikko ? ' / ' + ehdotus.yksikko : '' }}</span>
              }
            </button>
          }
          <button type="button" class="dd-new" [class.hi]="aktiivinenIndeksi() === ehdotukset().length" (mousedown)="$event.preventDefault(); lisaaVapaaRivi()" (mouseenter)="aktiivinenIndeksi.set(ehdotukset().length)">
            <mat-icon>edit</mat-icon>
            <span>{{ 'lasku.lisaa-rivi-nimella' | translate: { nimi: hakusana().value()?.trim() } | async }}</span>
          </button>
        </div>
      }
    </div>
  </td>
</tr>
